VjsAdmin.roleGoogleMapping = (function () {
    const me = {};
    const districtGuid = $('.district-info').data('district-guid');
    const platformId = $('.platform-info').data('platform-id');
    const roles = ['User', 'Staff', 'Administrator', 'Super Administrator'];

    const init = function () {
        const MappingView = new AddMappingView();
        MappingView.render(roles);
    };
    const successAlert = function (alertMessage) {
        const alert = `<div class="alert alert-success" role="alert">\
                            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>\
                            <span>${alertMessage}</span>\
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>\
                        </div>`;

        $('.alert-div').html(alert);
    };
    const dangerAlert = function (alertMessage) {
        const alert = `<div class="alert alert-danger" role="alert">\
                            <span>${alertMessage}</span>\
                        </div>`;
        $('.alert-div').html(alert);
    };

    const AddMappingView = VjsUtility.View.extend({
        parent: '#view-body',
        templateUrl: '/assets/templates/google/mapping/component-mapping-template.html',
        after() {
            roles.forEach((roleName) => {
                new me.MappingComponentView().render({
                    item_name: roleName,
                });
            });
        },
    });

    me.MappingComponentView = VjsUtility.View.extend({
        parent: '.component-view',
        templateUrl: '/assets/templates/google/mapping/mapping-component.html',
        events: {
            'click #add-direct-mapping': 'clickAddDirectMapping',
        },
        after(res) {
            $('.mapping-component').detach().appendTo('#added-component-view');
            const req = new VjsUtility.Request();
            req.get(
                `/platforms/${platformId}/districts/${districtGuid}/google/direct-mapping/?conditional_key=${res.item_name}&attribute_type=role`,
            )
                .done((resp) => {
                    resp.forEach((obj) => {
                        const thisRoleMapping = $(`.mapping-component[data-mapping-id="${obj.conditional_key}"]`);
                        const DirectMappingComponent = new me.DirectMappingComponentView();
                        DirectMappingComponent.parent = $(thisRoleMapping).find('.mapping-items-view');
                        DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/direct-mapping-component.html';
                        DirectMappingComponent.thisLicenseMapping = thisRoleMapping;
                        DirectMappingComponent.render({
                            mapping_key: obj.conditional_key,
                            mapping_value: obj.conditional_value,
                            id: obj.id,
                        });
                    });
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickAddDirectMapping(e) {
            const thisLicenseMapping = $(e.currentTarget).closest('.mapping-component');
            const DirectMappingComponent = new me.DirectMappingComponentView();
            DirectMappingComponent.parent = $(thisLicenseMapping).find('.mapping-items-view');
            DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/new-direct-mapping-component.html';
            DirectMappingComponent.thisLicenseMapping = thisLicenseMapping;
            DirectMappingComponent.render({
                mapping_key: $(e.currentTarget).data('mapping-attr'),
                mapping_value: '',
            });
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
    });

    me.DirectMappingComponentView = VjsUtility.View.extend({
        parent: '',
        thisLicenseMapping: '',
        events: {
            'click .save-direct-mapping': 'clickSaveDirectMapping',
            'click .delete-direct-mapping': 'clickDeleteDirectMapping',
            'click .edit-direct-mapping': 'clickEditDirectMapping',
            'click .cancel-direct-mapping': 'clickCancelDirectMapping',
        },
        after() {
            const addedLicenseMappings = $(this.thisLicenseMapping).find('.added-mapping-items');
            $(this.parent).find('.direct-mapping-component').detach().appendTo(addedLicenseMappings);
        },
        clickSaveDirectMapping(e) {
            const thisMapping = e.currentTarget;
            const createMappingData = {
                mapping_value: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').val(),
                mapping_key: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').data('mapping-key'),
                id: $(thisMapping).data('mapping-id'),
                attribute_type: 'role',
            };
            const req = new VjsUtility.Request();
            req.put(`/platforms/${platformId}/districts/${districtGuid}/google/direct-mapping/`, createMappingData)
                .done(() => {
                    const MappingView = new AddMappingView();
                    MappingView.render(roles);
                    successAlert('Mapping saved successfully');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickDeleteDirectMapping(e) {
            const mappingId = $(e.currentTarget).data('mapping-id');
            const req = new VjsUtility.Request();
            req.delete(`/platforms/${platformId}/districts/${districtGuid}/google/direct-mapping/${mappingId}`)
                .done(() => {
                    const MappingView = new AddMappingView();
                    MappingView.render(roles);
                    successAlert('Mapping deleted successfully');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickEditDirectMapping(e) {
            $(e.currentTarget).parent('.edit-button').attr('hidden', true);
            $(e.currentTarget).closest('.direct-mapping-component').find('.action-buttons').removeAttr('hidden');
            $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name').removeAttr('disabled');
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
        clickCancelDirectMapping() {
            // This rerenders the ui, if the refresh is too jarring we can change it to be more programmatic
            const MappingView = new AddMappingView();
            MappingView.render(roles);
        },
    });

    return {
        init,
    };
}());
